import { lazy, Suspense } from 'react';
import LoadingSection from '../LoadingSection';
import { jsx as _jsx } from "react/jsx-runtime";
const LazyTransitional = /*#__PURE__*/lazy(() => import('./HtmlSectionFormatter.transitional'));
const LazyAlpha = /*#__PURE__*/lazy(() => import('./HtmlSectionFormatter.alpha'));
const HtmlSectionFormatter = ({
  section,
  callbacks,
  trellisComponents
}) => /*#__PURE__*/_jsx(Suspense, {
  fallback: /*#__PURE__*/_jsx(LoadingSection, {}),
  children: trellisComponents ? /*#__PURE__*/_jsx(LazyAlpha, {
    section: section
  }) : /*#__PURE__*/_jsx(LazyTransitional, {
    section: section,
    callbacks: callbacks
  })
});
export default HtmlSectionFormatter;